import {
  Long2qws0ah9gnpki as Long,
  VOID7hggqo3abtya as VOID,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  Unit_instance104q5opgivhr8 as Unit_instance,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  SequenceScope1coiso86pqzq2 as SequenceScope,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  ArrayList_init_$Create$2qnngtk1et9r9 as ArrayList_init_$Create$,
  sequence2vgswtrxvqoa7 as sequence,
  toString1pkumu07cwy4m as toString,
  IllegalArgumentException_init_$Create$310sysrobvll9 as IllegalArgumentException_init_$Create$,
  abs1kdzbjes1idip as abs,
  StringBuilder_init_$Create$2mwec1027v00x as StringBuilder_init_$Create$,
  fill2542d4m9l93pn as fill,
  isIntArrayeijsubfngq38 as isIntArray,
  _Char___init__impl__6a9atx281r2pd9o601g as _Char___init__impl__6a9atx,
  endsWith1a79dp5rc3sfv as endsWith,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  Char19o2r8palgjof as Char,
  Char__compareTo_impl_ypi4mb3fw4vcbfqkuba as Char__compareTo_impl_ypi4mb,
  contains2el4s70rdq4ld as contains,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  Char__toInt_impl_vasixd2xlaiz5u3itpv as Char__toInt_impl_vasixd,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalStateException_init_$Init$13tvpwythio9e as IllegalStateException_init_$Init$,
  captureStack1fzi4aczwc4hg as captureStack,
  IllegalStateException_init_$Create$3ib9qa3pip8n4 as IllegalStateException_init_$Create$,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  setOf45ia9pnfhe90 as setOf,
  listOf1jh22dvmctj1r as listOf,
  toString1h6jjoch8cjt8 as toString_0,
  toByte4i43936u611k as toByte,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  startsWith641pyr7vf687 as startsWith,
  isInterface3d6p8outrmvmk as isInterface,
  CancellationException_init_$Create$tastk7hwpe6q as CancellationException_init_$Create$,
  toLongw1zpgk99d84b as toLong,
  LinkedHashMap_init_$Create$1p3p95clvi93w as LinkedHashMap_init_$Create$,
  compareTo3ankvs086tmwq as compareTo,
  NoSuchElementException_init_$Create$2u364tbvjhp4i as NoSuchElementException_init_$Create$,
  Collection1k04j3hzsbod0 as Collection,
  emptyList1g2z5xcrvp2zy as emptyList,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  StringBuilder_init_$Create$23o1ixl6cos5l as StringBuilder_init_$Create$_0,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  CharSequence1ceii1xorfwh7 as CharSequence,
  IndexOutOfBoundsException_init_$Create$jb51qtvf74or as IndexOutOfBoundsException_init_$Create$,
  charArray2ujmm1qusno00 as charArray,
  NumberFormatException_init_$Create$kedeltz3bzwr as NumberFormatException_init_$Create$,
  toString35i91qxh73cps as toString_1,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$1s1wkrw82c0iw as ArrayList_init_$Create$_0,
  numberToLong1a4cndvg6c52s as numberToLong,
  toLongArray23ixicpzp5r3w as toLongArray,
  Char__plus_impl_qi7pgj1zq2c0uiotg93 as Char__plus_impl_qi7pgj,
  Char__minus_impl_a2frrhe8uo2lu35qi1 as Char__minus_impl_a2frrh,
  toByteArray3caw0hip00os as toByteArray,
  isWhitespace25occ8z1ed1s9 as isWhitespace,
} from './kotlin-kotlin-stdlib.mjs';
import {
  MultiPartData57syw40llxls as MultiPartData,
  HttpHeaders_getInstancekqele34vb34f as HttpHeaders_getInstance,
  MultiPart_getInstance2x0sgwr24mfqp as MultiPart_getInstance,
  Companion_getInstancepumzx9q4106p as Companion_getInstance,
} from './ktor-ktor-http.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  produce1iljho2c8bp6o as produce,
  ProducerScopeb3mmhvfa6ll7 as ProducerScope,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
} from './kotlinx-coroutines-core.mjs';
import {
  DefaultPool2gb1fm4epwgu9 as DefaultPool,
  readUTF8LineTo2rqyj2iri7j7e as readUTF8LineTo,
  Companion_getInstance2golwmcx6d471 as Companion_getInstance_0,
  LineEndingMode__plus_impl_ttpz2j1fo728zjvbdzc as LineEndingMode__plus_impl_ttpz2j,
  readUntilqaod88ylrtua as readUntil,
  WriterScope3b0bo1enaee6b as WriterScope,
  counted3iniv3aql3f9n as counted,
  writer1eia5its2a1fh as writer,
  readRemaining33cdmbznvdvtg as readRemaining,
  get_remaining1lapv95kcmm0y as get_remaining,
  skipIfFound2s927ggnjlzu8 as skipIfFound,
  ByteChannel3cxdguezl3lu7 as ByteChannel,
  close3semq7pafb42g as close,
  readPacket12c3kakna35tv as readPacket,
  copyTo2bqjr21is71ky as copyTo,
  toByteArray1i3ns5jnoqlv6 as toByteArray_0,
  NoPoolImplgos9n8jphzjp as NoPoolImpl,
} from './ktor-ktor-io.mjs';
import {
  ByteString_init_$Create$szylcqpww4kx as ByteString_init_$Create$,
  ByteString3c9fk8lsh3lvs as ByteString,
} from './kotlinx-io-kotlinx-io-bytestring.mjs';
import {
  IOException_init_$Create$13y6ig657l2av as IOException_init_$Create$,
  EOFException_init_$Create$1fcl7h9im3v9r as EOFException_init_$Create$,
  IOException1wyutdmfe71nu as IOException,
  IOException_init_$Init$2jjz3fe04l3kq as IOException_init_$Init$,
} from './kotlinx-io-kotlinx-io-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForClass(CIOMultipartDataBase, 'CIOMultipartDataBase', VOID, VOID, [MultiPartData, CoroutineScope], [0, 1]);
initMetadataForLambda(HeadersData$headersStarts$slambda, CoroutineImpl, VOID, [1]);
initMetadataForClass(HeadersData, 'HeadersData', HeadersData);
initMetadataForClass(HttpHeadersMap, 'HttpHeadersMap');
initMetadataForClass(IntArrayPool$1, VOID, VOID, DefaultPool);
initMetadataForClass(HeadersDataPool$1, VOID, VOID, DefaultPool);
initMetadataForClass(ParserException, 'ParserException', VOID, IllegalStateException);
initMetadataForCoroutine($parseHeadersCOROUTINE$4, CoroutineImpl);
initMetadataForClass(MultipartEvent, 'MultipartEvent');
initMetadataForClass(Preamble, 'Preamble', VOID, MultipartEvent);
initMetadataForClass(MultipartPart, 'MultipartPart', VOID, MultipartEvent);
initMetadataForClass(Epilogue, 'Epilogue', VOID, MultipartEvent);
initMetadataForLambda(parseMultipart$slambda$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(parseMultipart$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($parsePartHeadersImplCOROUTINE$5, CoroutineImpl);
initMetadataForCoroutine($parsePartBodyImplCOROUTINE$6, CoroutineImpl);
initMetadataForCoroutine($skipIfFoundReadCountCOROUTINE$7, CoroutineImpl);
initMetadataForClass(Node, 'Node');
initMetadataForCompanion(Companion);
initMetadataForClass(AsciiCharTree, 'AsciiCharTree');
initMetadataForClass(SubSequenceImpl, 'SubSequenceImpl', VOID, VOID, [CharSequence]);
initMetadataForClass(CharArrayBuilder, 'CharArrayBuilder', CharArrayBuilder, VOID, [CharSequence]);
initMetadataForClass(CharArrayPool$1, VOID, VOID, NoPoolImpl);
initMetadataForClass(CharArrayPool$2, VOID, VOID, DefaultPool);
initMetadataForClass(UnsupportedMediaTypeExceptionCIO, 'UnsupportedMediaTypeExceptionCIO', VOID, IOException);
initMetadataForClass(MutableRange, 'MutableRange');
//endregion
function CIOMultipartDataBase(coroutineContext, channel, contentType, contentLength, formFieldLimit) {
  formFieldLimit = formFieldLimit === VOID ? new Long(65536, 0) : formFieldLimit;
  this.i47_1 = coroutineContext;
  this.j47_1 = null;
  this.k47_1 = parseMultipart(this, channel, contentType, contentLength, formFieldLimit);
}
protoOf(CIOMultipartDataBase).h1e = function () {
  return this.i47_1;
};
function get_IntArrayPool() {
  _init_properties_HttpHeadersMap_kt__hwatby();
  return IntArrayPool;
}
var IntArrayPool;
function get_HeadersDataPool() {
  _init_properties_HttpHeadersMap_kt__hwatby();
  return HeadersDataPool;
}
var HeadersDataPool;
function HeadersData$headersStarts$slambda(this$0, resultContinuation) {
  this.t47_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HeadersData$headersStarts$slambda).z47 = function ($this$sequence, $completion) {
  var tmp = this.a48($this$sequence, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(HeadersData$headersStarts$slambda).h9 = function (p1, $completion) {
  return this.z47(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
};
protoOf(HeadersData$headersStarts$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          this.v47_1 = 0;
          this.w47_1 = this.t47_1.b48_1.j();
          this.n8_1 = 1;
          continue $sm;
        case 1:
          if (!this.w47_1.k()) {
            this.n8_1 = 6;
            continue $sm;
          }

          this.x47_1 = this.w47_1.l();
          this.y47_1 = 0;
          this.n8_1 = 2;
          continue $sm;
        case 2:
          if (!(this.y47_1 < this.x47_1.length)) {
            this.n8_1 = 5;
            continue $sm;
          }

          if (!(this.t47_1.c48(this.v47_1 + 0 | 0) === -1)) {
            this.n8_1 = 3;
            suspendResult = this.u47_1.vf(this.v47_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 4;
            continue $sm;
          }

        case 3:
          this.n8_1 = 4;
          continue $sm;
        case 4:
          this.y47_1 = this.y47_1 + 6 | 0;
          this.v47_1 = this.v47_1 + 6 | 0;
          this.n8_1 = 2;
          continue $sm;
        case 5:
          this.n8_1 = 1;
          continue $sm;
        case 6:
          return Unit_instance;
        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 7) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(HeadersData$headersStarts$slambda).a48 = function ($this$sequence, completion) {
  var i = new HeadersData$headersStarts$slambda(this.t47_1, completion);
  i.u47_1 = $this$sequence;
  return i;
};
function HeadersData$headersStarts$slambda_0(this$0, resultContinuation) {
  var i = new HeadersData$headersStarts$slambda(this$0, resultContinuation);
  var l = function ($this$sequence, $completion) {
    return i.z47($this$sequence, $completion);
  };
  l.$arity = 1;
  return l;
}
function HeadersData() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.b48_1 = ArrayList_init_$Create$();
}
protoOf(HeadersData).d48 = function () {
  return this.b48_1.m();
};
protoOf(HeadersData).e48 = function (subArraysCount) {
  // Inline function 'kotlin.repeat' call
  var inductionVariable = 0;
  if (inductionVariable < subArraysCount)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this.b48_1.e(get_IntArrayPool().c3o());
    }
     while (inductionVariable < subArraysCount);
};
protoOf(HeadersData).c48 = function (index) {
  return this.b48_1.o(index / 768 | 0)[index % 768 | 0];
};
protoOf(HeadersData).f48 = function (index, value) {
  this.b48_1.o(index / 768 | 0)[index % 768 | 0] = value;
};
protoOf(HeadersData).g48 = function () {
  return sequence(HeadersData$headersStarts$slambda_0(this, null));
};
protoOf(HeadersData).a28 = function () {
  var _iterator__ex2g4s = this.b48_1.j();
  while (_iterator__ex2g4s.k()) {
    var array = _iterator__ex2g4s.l();
    get_IntArrayPool().d3o(array);
  }
  this.b48_1.d2();
};
function thresholdReached($this) {
  return $this.i48_1 >= $this.j48_1 * 0.75;
}
function resize($this) {
  var prevSize = $this.i48_1;
  var prevData = $this.k48_1;
  $this.i48_1 = 0;
  $this.j48_1 = imul($this.j48_1, 2) | 128;
  var tmp = $this;
  // Inline function 'kotlin.apply' call
  var this_0 = get_HeadersDataPool().c3o();
  this_0.e48(imul(prevData.d48(), 2) | 1);
  tmp.k48_1 = this_0;
  var _iterator__ex2g4s = prevData.g48().j();
  while (_iterator__ex2g4s.k()) {
    var headerOffset = _iterator__ex2g4s.l();
    $this.l48(prevData.c48(headerOffset + 1 | 0), prevData.c48(headerOffset + 2 | 0), prevData.c48(headerOffset + 3 | 0), prevData.c48(headerOffset + 4 | 0));
  }
  get_HeadersDataPool().d3o(prevData);
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(prevSize === $this.i48_1)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
function headerHasName($this, name, headerOffset) {
  var nameStartIndex = $this.k48_1.c48(headerOffset + 1 | 0);
  var nameEndIndex = $this.k48_1.c48(headerOffset + 2 | 0);
  return equalsLowerCase($this.h48_1, nameStartIndex, nameEndIndex, name);
}
function HttpHeadersMap(builder) {
  this.h48_1 = builder;
  this.i48_1 = 0;
  this.j48_1 = 0;
  this.k48_1 = get_HeadersDataPool().c3o();
}
protoOf(HttpHeadersMap).h2a = function (name) {
  if (this.i48_1 === 0)
    return null;
  // Inline function 'kotlin.math.absoluteValue' call
  var this_0 = hashCodeLowerCase(name);
  var hash = abs(this_0);
  var headerIndex = hash % this.j48_1 | 0;
  while (!(this.k48_1.c48(imul(headerIndex, 6) + 0 | 0) === -1)) {
    if (headerHasName(this, name, imul(headerIndex, 6))) {
      return this.m48(imul(headerIndex, 6));
    }
    headerIndex = (headerIndex + 1 | 0) % this.j48_1 | 0;
  }
  return null;
};
protoOf(HttpHeadersMap).n48 = function () {
  return this.k48_1.g48();
};
protoOf(HttpHeadersMap).l48 = function (nameStartIndex, nameEndIndex, valueStartIndex, valueEndIndex) {
  if (thresholdReached(this)) {
    resize(this);
  }
  // Inline function 'kotlin.math.absoluteValue' call
  var this_0 = hashCodeLowerCase(this.h48_1, nameStartIndex, nameEndIndex);
  var hash = abs(this_0);
  var name = this.h48_1.c(nameStartIndex, nameEndIndex);
  var headerIndex = hash % this.j48_1 | 0;
  var sameNameHeaderIndex = -1;
  while (!(this.k48_1.c48(imul(headerIndex, 6) + 0 | 0) === -1)) {
    if (headerHasName(this, name, imul(headerIndex, 6))) {
      sameNameHeaderIndex = headerIndex;
    }
    headerIndex = (headerIndex + 1 | 0) % this.j48_1 | 0;
  }
  var headerOffset = imul(headerIndex, 6);
  this.k48_1.f48(headerOffset + 0 | 0, hash);
  this.k48_1.f48(headerOffset + 1 | 0, nameStartIndex);
  this.k48_1.f48(headerOffset + 2 | 0, nameEndIndex);
  this.k48_1.f48(headerOffset + 3 | 0, valueStartIndex);
  this.k48_1.f48(headerOffset + 4 | 0, valueEndIndex);
  this.k48_1.f48(headerOffset + 5 | 0, -1);
  if (!(sameNameHeaderIndex === -1)) {
    this.k48_1.f48(imul(sameNameHeaderIndex, 6) + 5 | 0, headerIndex);
  }
  this.i48_1 = this.i48_1 + 1 | 0;
};
protoOf(HttpHeadersMap).v48 = function (headerOffset) {
  var nameStartIndex = this.k48_1.c48(headerOffset + 1 | 0);
  var nameEndIndex = this.k48_1.c48(headerOffset + 2 | 0);
  return this.h48_1.c(nameStartIndex, nameEndIndex);
};
protoOf(HttpHeadersMap).m48 = function (headerOffset) {
  var valueStartIndex = this.k48_1.c48(headerOffset + 3 | 0);
  var valueEndIndex = this.k48_1.c48(headerOffset + 4 | 0);
  return this.h48_1.c(valueStartIndex, valueEndIndex);
};
protoOf(HttpHeadersMap).a28 = function () {
  this.i48_1 = 0;
  this.j48_1 = 0;
  get_HeadersDataPool().d3o(this.k48_1);
  this.k48_1 = get_HeadersDataPool().c3o();
};
protoOf(HttpHeadersMap).toString = function () {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  dumpTo(this, '', this_0);
  return this_0.toString();
};
function dumpTo(_this__u8e3s4, indent, out) {
  _init_properties_HttpHeadersMap_kt__hwatby();
  var _iterator__ex2g4s = _this__u8e3s4.n48().j();
  while (_iterator__ex2g4s.k()) {
    var offset = _iterator__ex2g4s.l();
    out.f(indent);
    out.f(_this__u8e3s4.v48(offset));
    out.f(' => ');
    out.f(_this__u8e3s4.m48(offset));
    out.f('\n');
  }
}
function IntArrayPool$1() {
  DefaultPool.call(this, 1000);
}
protoOf(IntArrayPool$1).v3n = function () {
  var tmp = 0;
  var tmp_0 = new Int32Array(768);
  while (tmp < 768) {
    tmp_0[tmp] = -1;
    tmp = tmp + 1 | 0;
  }
  return tmp_0;
};
protoOf(IntArrayPool$1).z48 = function (instance) {
  fill(instance, -1);
  return protoOf(DefaultPool).a3o.call(this, instance);
};
protoOf(IntArrayPool$1).a3o = function (instance) {
  return this.z48(isIntArray(instance) ? instance : THROW_CCE());
};
function HeadersDataPool$1() {
  DefaultPool.call(this, 1000);
}
protoOf(HeadersDataPool$1).v3n = function () {
  return new HeadersData();
};
protoOf(HeadersDataPool$1).d49 = function (instance) {
  instance.a28();
  return protoOf(DefaultPool).a3o.call(this, instance);
};
protoOf(HeadersDataPool$1).a3o = function (instance) {
  return this.d49(instance instanceof HeadersData ? instance : THROW_CCE());
};
var properties_initialized_HttpHeadersMap_kt_kotj4w;
function _init_properties_HttpHeadersMap_kt__hwatby() {
  if (!properties_initialized_HttpHeadersMap_kt_kotj4w) {
    properties_initialized_HttpHeadersMap_kt_kotj4w = true;
    IntArrayPool = new IntArrayPool$1();
    HeadersDataPool = new HeadersDataPool$1();
  }
}
function get_hostForbiddenSymbols() {
  _init_properties_HttpParser_kt__gbdom1();
  return hostForbiddenSymbols;
}
var hostForbiddenSymbols;
function get_httpLineEndings() {
  _init_properties_HttpParser_kt__gbdom1();
  return httpLineEndings;
}
var httpLineEndings;
var versions;
function parseHeaders(input, builder, range, $completion) {
  range = range === VOID ? new MutableRange(0, 0) : range;
  var tmp = new $parseHeadersCOROUTINE$4(input, builder, range, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function parseHeaderName(text, range) {
  _init_properties_HttpParser_kt__gbdom1();
  var index = range.q49_1;
  var end = range.r49_1;
  while (index < end) {
    var ch = text.b(index);
    if (ch === _Char___init__impl__6a9atx(58) && !(index === range.q49_1)) {
      range.q49_1 = index + 1 | 0;
      return index;
    }
    if (isDelimiter(ch)) {
      parseHeaderNameFailed(text, index, range.q49_1, ch);
    }
    index = index + 1 | 0;
  }
  noColonFound(text, range);
}
function parseHeaderValue(text, range) {
  _init_properties_HttpParser_kt__gbdom1();
  var start = range.q49_1;
  var end = range.r49_1;
  var index = start;
  index = skipSpacesAndHorizontalTabs(text, index, end);
  if (index >= end) {
    range.q49_1 = end;
    return Unit_instance;
  }
  var valueStart = index;
  var valueLastIndex = index;
  while (index < end) {
    var ch = text.b(index);
    if (ch !== _Char___init__impl__6a9atx(9) && ch !== _Char___init__impl__6a9atx(32))
      if (ch === _Char___init__impl__6a9atx(13) || ch === _Char___init__impl__6a9atx(10)) {
        characterIsNotAllowed(text, ch);
      } else
        valueLastIndex = index;
    index = index + 1 | 0;
  }
  range.q49_1 = valueStart;
  range.r49_1 = valueLastIndex + 1 | 0;
}
function validateHostHeader(host) {
  _init_properties_HttpParser_kt__gbdom1();
  if (endsWith(host, ':')) {
    throw new ParserException("Host header with ':' should contains port: " + toString(host));
  }
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.text.any' call
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(host)) {
      var element = charSequenceGet(host, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      if (get_hostForbiddenSymbols().u1(new Char(element))) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  if (tmp$ret$1) {
    throw new ParserException('Host cannot contain any of the following symbols: ' + toString(get_hostForbiddenSymbols()));
  }
}
function isDelimiter(ch) {
  _init_properties_HttpParser_kt__gbdom1();
  return Char__compareTo_impl_ypi4mb(ch, _Char___init__impl__6a9atx(32)) <= 0 || contains('"(),/:;<=>?@[\\]{}', ch);
}
function parseHeaderNameFailed(text, index, start, ch) {
  _init_properties_HttpParser_kt__gbdom1();
  if (ch === _Char___init__impl__6a9atx(58)) {
    throw new ParserException('Empty header names are not allowed as per RFC7230.');
  }
  if (index === start) {
    throw new ParserException('Multiline headers via line folding is not supported since it is deprecated as per RFC7230.');
  }
  characterIsNotAllowed(text, ch);
}
function noColonFound(text, range) {
  _init_properties_HttpParser_kt__gbdom1();
  var tmp1 = range.q49_1;
  // Inline function 'kotlin.text.substring' call
  var endIndex = range.r49_1;
  var tmp$ret$0 = toString(charSequenceSubSequence(text, tmp1, endIndex));
  throw new ParserException('No colon in HTTP header in ' + tmp$ret$0 + ' in builder: \n' + toString(text));
}
function characterIsNotAllowed(text, ch) {
  _init_properties_HttpParser_kt__gbdom1();
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(ch);
  throw new ParserException('Character with code ' + (tmp$ret$0 & 255) + ' is not allowed in header names, \n' + toString(text));
}
function ParserException(message) {
  IllegalStateException_init_$Init$(message, this);
  captureStack(this, ParserException);
}
function $parseHeadersCOROUTINE$4(input, builder, range, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.m49_1 = input;
  this.n49_1 = builder;
  this.o49_1 = range;
}
protoOf($parseHeadersCOROUTINE$4).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          this.p49_1 = new HttpHeadersMap(this.n49_1);
          this.o8_1 = 6;
          this.n8_1 = 1;
          continue $sm;
        case 1:
          if (!true) {
            this.n8_1 = 5;
            continue $sm;
          }

          this.n8_1 = 2;
          suspendResult = readUTF8LineTo(this.m49_1, this.n49_1, 8192, get_httpLineEndings(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          var ARGUMENT = suspendResult;
          if (!ARGUMENT) {
            this.p49_1.a28();
            return null;
          } else {
            this.n8_1 = 3;
            continue $sm;
          }

        case 3:
          this.o49_1.r49_1 = this.n49_1.u48_1;
          var rangeLength = this.o49_1.r49_1 - this.o49_1.q49_1 | 0;
          if (rangeLength === 0) {
            this.n8_1 = 5;
            continue $sm;
          } else {
            this.n8_1 = 4;
            continue $sm;
          }

        case 4:
          if (rangeLength >= 8192) {
            var message = 'Header line length limit exceeded';
            throw IllegalStateException_init_$Create$(toString(message));
          }

          var nameStart = this.o49_1.q49_1;
          var nameEnd = parseHeaderName(this.n49_1, this.o49_1);
          var headerEnd = this.o49_1.r49_1;
          parseHeaderValue(this.n49_1, this.o49_1);
          var valueStart = this.o49_1.q49_1;
          var valueEnd = this.o49_1.r49_1;
          this.o49_1.q49_1 = headerEnd;
          this.p49_1.l48(nameStart, nameEnd, valueStart, valueEnd);
          this.n8_1 = 1;
          continue $sm;
        case 5:
          var host = this.p49_1.h2a(HttpHeaders_getInstance().f3y_1);
          if (!(host == null)) {
            validateHostHeader(host);
          }

          return this.p49_1;
        case 6:
          this.o8_1 = 7;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof Error) {
            var t = this.q8_1;
            this.p49_1.a28();
            throw t;
          } else {
            throw this.q8_1;
          }

        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 7) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
var properties_initialized_HttpParser_kt_uedryv;
function _init_properties_HttpParser_kt__gbdom1() {
  if (!properties_initialized_HttpParser_kt_uedryv) {
    properties_initialized_HttpParser_kt_uedryv = true;
    hostForbiddenSymbols = setOf([new Char(_Char___init__impl__6a9atx(47)), new Char(_Char___init__impl__6a9atx(63)), new Char(_Char___init__impl__6a9atx(35)), new Char(_Char___init__impl__6a9atx(64))]);
    httpLineEndings = LineEndingMode__plus_impl_ttpz2j(Companion_getInstance_0().i3h_1, Companion_getInstance_0().h3h_1);
    versions = Companion_instance.s49(listOf(['HTTP/1.0', 'HTTP/1.1']));
  }
}
function get_CrLf() {
  _init_properties_Multipart_kt__ato98a();
  return CrLf;
}
var CrLf;
function get_PrefixString() {
  _init_properties_Multipart_kt__ato98a();
  return PrefixString;
}
var PrefixString;
function Preamble(body) {
  MultipartEvent.call(this);
  this.t49_1 = body;
}
function MultipartPart(headers, body) {
  MultipartEvent.call(this);
  this.u49_1 = headers;
  this.v49_1 = body;
}
function Epilogue(body) {
  MultipartEvent.call(this);
  this.w49_1 = body;
}
function MultipartEvent() {
}
function parseMultipart(_this__u8e3s4, input, contentType, contentLength, maxPartSize) {
  maxPartSize = maxPartSize === VOID ? new Long(-1, 2147483647) : maxPartSize;
  _init_properties_Multipart_kt__ato98a();
  if (!MultiPart_getInstance().w3v(contentType)) {
    throw new UnsupportedMediaTypeExceptionCIO('Failed to parse multipart: Content-Type should be multipart/* but it is ' + toString(contentType));
  }
  var boundaryByteBuffer = parseBoundaryInternal(contentType);
  var boundaryBytes = ByteString_init_$Create$(boundaryByteBuffer);
  return parseMultipart_0(_this__u8e3s4, boundaryBytes, input, contentLength, maxPartSize);
}
function parseBoundaryInternal(contentType) {
  _init_properties_Multipart_kt__ato98a();
  var boundaryParameter = findBoundary(contentType);
  if (boundaryParameter === -1) {
    throw IOException_init_$Create$("Failed to parse multipart: Content-Type's boundary parameter is missing");
  }
  var boundaryStart = boundaryParameter + 9 | 0;
  var boundaryBytes = new Int8Array(74);
  var position = {_v: 0};
  parseBoundaryInternal$put(position, boundaryBytes, 13);
  parseBoundaryInternal$put(position, boundaryBytes, 10);
  parseBoundaryInternal$put(position, boundaryBytes, 45);
  parseBoundaryInternal$put(position, boundaryBytes, 45);
  var state = 0;
  var inductionVariable = boundaryStart;
  var last = charSequenceLength(contentType);
  if (inductionVariable < last)
    loop: do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ch = charSequenceGet(contentType, i);
      // Inline function 'kotlin.code' call
      var v = Char__toInt_impl_vasixd(ch) & 65535;
      if ((v & 65535) > 127) {
        throw IOException_init_$Create$('Failed to parse multipart: wrong boundary byte 0x' + toString_0(v, 16) + ' - should be 7bit character');
      }
      switch (state) {
        case 0:
          if (ch !== _Char___init__impl__6a9atx(32))
            if (ch === _Char___init__impl__6a9atx(34)) {
              state = 2;
            } else if (ch === _Char___init__impl__6a9atx(59) || ch === _Char___init__impl__6a9atx(44)) {
              break loop;
            } else {
              state = 1;
              parseBoundaryInternal$put(position, boundaryBytes, toByte(v));
            }

          break;
        case 1:
          if (ch === _Char___init__impl__6a9atx(32) || ch === _Char___init__impl__6a9atx(44) || ch === _Char___init__impl__6a9atx(59)) {
            break loop;
          } else {
            parseBoundaryInternal$put(position, boundaryBytes, toByte(v));
          }

          break;
        case 2:
          if (ch === _Char___init__impl__6a9atx(92)) {
            state = 3;
          } else if (ch === _Char___init__impl__6a9atx(34)) {
            break loop;
          } else {
            parseBoundaryInternal$put(position, boundaryBytes, toByte(v));
          }

          break;
        case 3:
          parseBoundaryInternal$put(position, boundaryBytes, toByte(v));
          state = 2;
          break;
      }
    }
     while (inductionVariable < last);
  if (position._v === 4) {
    throw IOException_init_$Create$('Empty multipart boundary is not allowed');
  }
  return copyOfRange(boundaryBytes, 0, position._v);
}
function parseMultipart_0(_this__u8e3s4, boundaryPrefixed, input, totalLength, maxPartSize) {
  _init_properties_Multipart_kt__ato98a();
  return produce(_this__u8e3s4, VOID, VOID, parseMultipart$slambda_0(input, boundaryPrefixed, maxPartSize, totalLength, null));
}
function findBoundary(contentType) {
  _init_properties_Multipart_kt__ato98a();
  var state = 0;
  var paramNameCount = 0;
  var inductionVariable = 0;
  var last = charSequenceLength(contentType) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ch = charSequenceGet(contentType, i);
      switch (state) {
        case 0:
          if (ch === _Char___init__impl__6a9atx(59)) {
            state = 1;
            paramNameCount = 0;
          }

          break;
        case 1:
          if (ch === _Char___init__impl__6a9atx(61)) {
            state = 2;
          } else if (ch === _Char___init__impl__6a9atx(59)) {
            paramNameCount = 0;
          } else if (ch === _Char___init__impl__6a9atx(44)) {
            state = 0;
          } else if (ch !== _Char___init__impl__6a9atx(32))
            if (paramNameCount === 0 && startsWith(contentType, 'boundary=', i, true)) {
              return i;
            } else {
              paramNameCount = paramNameCount + 1 | 0;
            }

          break;
        case 2:
          if (ch === _Char___init__impl__6a9atx(34))
            state = 3;
          else if (ch === _Char___init__impl__6a9atx(44))
            state = 0;
          else if (ch === _Char___init__impl__6a9atx(59)) {
            state = 1;
            paramNameCount = 0;
          }

          break;
        case 3:
          if (ch === _Char___init__impl__6a9atx(34)) {
            state = 1;
            paramNameCount = 0;
          } else if (ch === _Char___init__impl__6a9atx(92)) {
            state = 4;
          }

          break;
        case 4:
          state = 3;
          break;
      }
    }
     while (inductionVariable <= last);
  return -1;
}
function parsePreambleImpl(boundary, input, output, limit, $completion) {
  limit = limit === VOID ? new Long(-1, 2147483647) : limit;
  return readUntil(input, boundary, output, limit, true, $completion);
}
function parsePartHeadersImpl(input, $completion) {
  var tmp = new $parsePartHeadersImplCOROUTINE$5(input, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function parsePartBodyImpl(boundaryPrefixed, input, output, headers, limit, $completion) {
  var tmp = new $parsePartBodyImplCOROUTINE$6(boundaryPrefixed, input, output, headers, limit, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function skipIfFoundReadCount(_this__u8e3s4, prefix, $completion) {
  var tmp = new $skipIfFoundReadCountCOROUTINE$7(_this__u8e3s4, prefix, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function throwLimitExceeded(actual, limit) {
  _init_properties_Multipart_kt__ato98a();
  throw IOException_init_$Create$('Multipart content length exceeds limit ' + actual.toString() + ' > ' + limit.toString() + '; ' + "limit is defined using 'formFieldLimit' argument");
}
function parseBoundaryInternal$put(position, boundaryBytes, value) {
  if (position._v >= boundaryBytes.length) {
    throw IOException_init_$Create$("Failed to parse multipart: boundary shouldn't be longer than 70 characters");
  }
  var _unary__edvuaz = position._v;
  position._v = _unary__edvuaz + 1 | 0;
  boundaryBytes[_unary__edvuaz] = value;
}
function parseMultipart$slambda$slambda($firstBoundary, $countedInput, resultContinuation) {
  this.s4b_1 = $firstBoundary;
  this.t4b_1 = $countedInput;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(parseMultipart$slambda$slambda).v4b = function ($this$writer, $completion) {
  var tmp = this.w4b($this$writer, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(parseMultipart$slambda$slambda).h9 = function (p1, $completion) {
  return this.v4b(p1 instanceof WriterScope ? p1 : THROW_CCE(), $completion);
};
protoOf(parseMultipart$slambda$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = parsePreambleImpl(this.s4b_1, this.t4b_1, this.u4b_1.z3k_1, new Long(8193, 0), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.n8_1 = 2;
          suspendResult = this.u4b_1.z3k_1.a3e(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return Unit_instance;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(parseMultipart$slambda$slambda).w4b = function ($this$writer, completion) {
  var i = new parseMultipart$slambda$slambda(this.s4b_1, this.t4b_1, completion);
  i.u4b_1 = $this$writer;
  return i;
};
function parseMultipart$slambda$slambda_0($firstBoundary, $countedInput, resultContinuation) {
  var i = new parseMultipart$slambda$slambda($firstBoundary, $countedInput, resultContinuation);
  var l = function ($this$writer, $completion) {
    return i.v4b($this$writer, $completion);
  };
  l.$arity = 1;
  return l;
}
function parseMultipart$slambda($input, $boundaryPrefixed, $maxPartSize, $totalLength, resultContinuation) {
  this.f4c_1 = $input;
  this.g4c_1 = $boundaryPrefixed;
  this.h4c_1 = $maxPartSize;
  this.i4c_1 = $totalLength;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(parseMultipart$slambda).a4d = function ($this$produce, $completion) {
  var tmp = this.b4d($this$produce, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(parseMultipart$slambda).h9 = function (p1, $completion) {
  return this.a4d((!(p1 == null) ? isInterface(p1, ProducerScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(parseMultipart$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 23;
          this.k4c_1 = counted(this.f4c_1);
          this.l4c_1 = this.k4c_1.j3n();
          this.m4c_1 = this.g4c_1.c38(get_PrefixString().m());
          this.n8_1 = 1;
          suspendResult = readRemaining(writer(this.j4c_1, VOID, VOID, parseMultipart$slambda$slambda_0(this.m4c_1, this.k4c_1, null)).x3k_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.n4c_1 = suspendResult;
          if (get_remaining(this.n4c_1).b1(new Long(0, 0)) > 0) {
            this.n8_1 = 2;
            suspendResult = this.j4c_1.o1w(new Preamble(this.n4c_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 3;
            continue $sm;
          }

        case 2:
          this.n8_1 = 3;
          continue $sm;
        case 3:
          this.n8_1 = 4;
          continue $sm;
        case 4:
          if (!this.k4c_1.x3d()) {
            this.n8_1 = 5;
            suspendResult = skipIfFound(this.k4c_1, get_PrefixString(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.o4c_1 = false;
            this.n8_1 = 6;
            continue $sm;
          }

        case 5:
          this.p4c_1 = suspendResult;
          this.o4c_1 = !this.p4c_1;
          this.n8_1 = 6;
          continue $sm;
        case 6:
          if (!this.o4c_1) {
            this.n8_1 = 13;
            continue $sm;
          }

          this.n8_1 = 7;
          suspendResult = skipIfFound(this.k4c_1, get_CrLf(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 7:
          this.q4c_1 = new ByteChannel();
          this.r4c_1 = CompletableDeferred();
          this.s4c_1 = new MultipartPart(this.r4c_1, this.q4c_1);
          this.n8_1 = 8;
          suspendResult = this.j4c_1.o1w(this.s4c_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 8:
          this.t4c_1 = null;
          this.o8_1 = 12;
          this.n8_1 = 9;
          suspendResult = parsePartHeadersImpl(this.k4c_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 9:
          this.t4c_1 = suspendResult;
          if (!this.r4c_1.c1l(this.t4c_1)) {
            this.t4c_1.a28();
            throw CancellationException_init_$Create$('Multipart processing has been cancelled');
          }

          this.n8_1 = 10;
          suspendResult = parsePartBodyImpl(this.g4c_1, this.k4c_1, this.q4c_1, this.t4c_1, this.h4c_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 10:
          this.q4c_1.a4();
          this.o8_1 = 23;
          this.n8_1 = 11;
          continue $sm;
        case 11:
          this.o8_1 = 23;
          this.n8_1 = 4;
          continue $sm;
        case 12:
          this.o8_1 = 23;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof Error) {
            this.u4c_1 = this.q8_1;
            if (this.r4c_1.d1l(this.u4c_1)) {
              var tmp0_safe_receiver = this.t4c_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.a28();
              }
            }
            close(this.q4c_1, this.u4c_1);
            throw this.u4c_1;
          } else {
            throw this.q8_1;
          }

        case 13:
          this.n8_1 = 14;
          suspendResult = skipIfFound(this.k4c_1, get_CrLf(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 14:
          this.n8_1 = 15;
          suspendResult = skipIfFound(this.k4c_1, get_CrLf(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 15:
          if (!(this.i4c_1 == null)) {
            this.v4c_1 = this.k4c_1.j3n().s2(this.l4c_1);
            this.w4c_1 = this.i4c_1.s2(this.v4c_1);
            if (this.w4c_1.b1(new Long(2147483647, 0)) > 0)
              throw IOException_init_$Create$('Failed to parse multipart: prologue is too long');
            if (this.w4c_1.b1(new Long(0, 0)) > 0) {
              this.n8_1 = 19;
              suspendResult = readPacket(this.k4c_1, this.w4c_1.d1(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n8_1 = 21;
              continue $sm;
            }
          } else {
            this.n8_1 = 16;
            suspendResult = readRemaining(this.k4c_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          }

        case 16:
          this.x4c_1 = suspendResult;
          if (!this.x4c_1.k38()) {
            this.n8_1 = 17;
            suspendResult = this.j4c_1.o1w(new Epilogue(this.x4c_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 18;
            continue $sm;
          }

        case 17:
          this.n8_1 = 18;
          continue $sm;
        case 18:
          this.n8_1 = 22;
          continue $sm;
        case 19:
          this.y4c_1 = suspendResult;
          this.z4c_1 = new Epilogue(this.y4c_1);
          this.n8_1 = 20;
          suspendResult = this.j4c_1.o1w(this.z4c_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 20:
          this.n8_1 = 21;
          continue $sm;
        case 21:
          this.n8_1 = 22;
          continue $sm;
        case 22:
          return Unit_instance;
        case 23:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 23) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(parseMultipart$slambda).b4d = function ($this$produce, completion) {
  var i = new parseMultipart$slambda(this.f4c_1, this.g4c_1, this.h4c_1, this.i4c_1, completion);
  i.j4c_1 = $this$produce;
  return i;
};
function parseMultipart$slambda_0($input, $boundaryPrefixed, $maxPartSize, $totalLength, resultContinuation) {
  var i = new parseMultipart$slambda($input, $boundaryPrefixed, $maxPartSize, $totalLength, resultContinuation);
  var l = function ($this$produce, $completion) {
    return i.a4d($this$produce, $completion);
  };
  l.$arity = 1;
  return l;
}
function $parsePartHeadersImplCOROUTINE$5(input, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.f4a_1 = input;
}
protoOf($parsePartHeadersImplCOROUTINE$5).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.g4a_1 = new CharArrayBuilder();
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = parseHeaders(this.f4a_1, this.g4a_1, VOID, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var tmp0_elvis_lhs = suspendResult;
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            throw EOFException_init_$Create$('Failed to parse multipart headers: unexpected end of stream');
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }

          return tmp_0;
        case 2:
          this.o8_1 = 3;
          var tmp_1 = this.q8_1;
          if (tmp_1 instanceof Error) {
            var t = this.q8_1;
            this.g4a_1.a28();
            throw t;
          } else {
            throw this.q8_1;
          }

        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $parsePartBodyImplCOROUTINE$6(boundaryPrefixed, input, output, headers, limit, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.p4a_1 = boundaryPrefixed;
  this.q4a_1 = input;
  this.r4a_1 = output;
  this.s4a_1 = headers;
  this.t4a_1 = limit;
}
protoOf($parsePartBodyImplCOROUTINE$6).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 6;
          var tmp_0 = this;
          var tmp0_safe_receiver = this.s4a_1.h2a('Content-Length');
          tmp_0.u4a_1 = tmp0_safe_receiver == null ? null : parseDecLong(tmp0_safe_receiver);
          if (this.u4a_1 == null) {
            this.n8_1 = 3;
            suspendResult = readUntil(this.q4a_1, this.p4a_1, this.r4a_1, this.t4a_1, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            if ((new Long(0, 0)).a3(this.t4a_1).mi(this.u4a_1)) {
              this.n8_1 = 1;
              suspendResult = copyTo(this.q4a_1, this.r4a_1, this.u4a_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1 = this;
              throwLimitExceeded(this.u4a_1, this.t4a_1);
            }
          }

          break;
        case 1:
          this.w4a_1 = suspendResult;
          this.n8_1 = 2;
          suspendResult = skipIfFoundReadCount(this.q4a_1, this.p4a_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.x4a_1 = suspendResult;
          this.v4a_1 = this.w4a_1.r2(this.x4a_1);
          this.n8_1 = 4;
          continue $sm;
        case 3:
          this.v4a_1 = suspendResult;
          this.n8_1 = 4;
          continue $sm;
        case 4:
          this.y4a_1 = this.v4a_1;
          this.n8_1 = 5;
          suspendResult = this.r4a_1.p3d(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 5:
          return this.y4a_1;
        case 6:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 6) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $skipIfFoundReadCountCOROUTINE$7(_this__u8e3s4, prefix, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.h4b_1 = _this__u8e3s4;
  this.i4b_1 = prefix;
}
protoOf($skipIfFoundReadCountCOROUTINE$7).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = skipIfFound(this.h4b_1, this.i4b_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          if (suspendResult) {
            var tmp_0 = this;
            tmp_0.j4b_1 = toLong(this.i4b_1.m());
            this.n8_1 = 2;
            continue $sm;
          } else {
            var tmp_1 = this;
            tmp_1.j4b_1 = new Long(0, 0);
            this.n8_1 = 2;
            continue $sm;
          }

        case 2:
          return this.j4b_1;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
var properties_initialized_Multipart_kt_wu0sh0;
function _init_properties_Multipart_kt__ato98a() {
  if (!properties_initialized_Multipart_kt_wu0sh0) {
    properties_initialized_Multipart_kt_wu0sh0 = true;
    CrLf = ByteString_init_$Create$(toByteArray_0('\r\n'));
    PrefixString = ByteString(new Int8Array([45, 45]));
  }
}
function build($this, resultList, from, maxLength, idx, length, charAt) {
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap_init_$Create$();
  var _iterator__ex2g4s = from.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var key = charAt(element, idx);
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.a2(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$();
      destination.h2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.e(element);
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_0 = destination.r().j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    // Inline function 'kotlin.collections.component1' call
    var ch = element_0.s().i1_1;
    // Inline function 'kotlin.collections.component2' call
    var list_0 = element_0.t();
    var nextIdx = idx + 1 | 0;
    var children = ArrayList_init_$Create$();
    var tmp_0 = Companion_instance;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_1 = list_0.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_1 = _iterator__ex2g4s_1.l();
      if (length(element_1) > nextIdx) {
        destination_0.e(element_1);
      }
    }
    build(tmp_0, children, destination_0, maxLength, nextIdx, length, charAt);
    children.j5();
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_2 = list_0.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_2 = _iterator__ex2g4s_2.l();
      if (length(element_2) === nextIdx) {
        destination_1.e(element_2);
      }
    }
    resultList.e(new Node(ch, destination_1, children));
  }
}
function AsciiCharTree$Companion$build$lambda(it) {
  return charSequenceLength(it);
}
function AsciiCharTree$Companion$build$lambda_0(s, idx) {
  return new Char(charSequenceGet(s, idx));
}
function Node(ch, exact, children) {
  this.c4d_1 = ch;
  this.d4d_1 = exact;
  this.e4d_1 = children;
  var tmp = this;
  var tmp_0 = 0;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_1 = Array(256);
  while (tmp_0 < 256) {
    var tmp_2 = tmp_0;
    var tmp1 = this.e4d_1;
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.collections.singleOrNull' call
      var single = null;
      var found = false;
      var _iterator__ex2g4s = tmp1.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        // Inline function 'kotlin.code' call
        var this_0 = element.c4d_1;
        if (Char__toInt_impl_vasixd(this_0) === tmp_2) {
          if (found) {
            tmp$ret$3 = null;
            break $l$block_0;
          }
          single = element;
          found = true;
        }
      }
      if (!found) {
        tmp$ret$3 = null;
        break $l$block_0;
      }
      tmp$ret$3 = single;
    }
    tmp_1[tmp_2] = tmp$ret$3;
    tmp_0 = tmp_0 + 1 | 0;
  }
  tmp.f4d_1 = tmp_1;
}
function Companion() {
}
protoOf(Companion).s49 = function (from) {
  var tmp = AsciiCharTree$Companion$build$lambda;
  return this.g4d(from, tmp, AsciiCharTree$Companion$build$lambda_0);
};
protoOf(Companion).g4d = function (from, length, charAt) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.maxByOrNull' call
    var iterator = from.j();
    if (!iterator.k()) {
      tmp$ret$0 = null;
      break $l$block_0;
    }
    var maxElem = iterator.l();
    if (!iterator.k()) {
      tmp$ret$0 = maxElem;
      break $l$block_0;
    }
    var maxValue = length(maxElem);
    do {
      var e = iterator.l();
      var v = length(e);
      if (compareTo(maxValue, v) < 0) {
        maxElem = e;
        maxValue = v;
      }
    }
     while (iterator.k());
    tmp$ret$0 = maxElem;
  }
  var tmp0_safe_receiver = tmp$ret$0;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = length(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    throw NoSuchElementException_init_$Create$('Unable to build char tree from an empty list');
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var maxLen = tmp_0;
  var tmp$ret$2;
  $l$block_2: {
    // Inline function 'kotlin.collections.any' call
    var tmp_1;
    if (isInterface(from, Collection)) {
      tmp_1 = from.p();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp$ret$2 = false;
      break $l$block_2;
    }
    var _iterator__ex2g4s = from.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (length(element) === 0) {
        tmp$ret$2 = true;
        break $l$block_2;
      }
    }
    tmp$ret$2 = false;
  }
  if (tmp$ret$2)
    throw IllegalArgumentException_init_$Create$('There should be no empty entries');
  var root = ArrayList_init_$Create$();
  build(this, root, from, maxLen, 0, length, charAt);
  root.j5();
  return new AsciiCharTree(new Node(_Char___init__impl__6a9atx(0), emptyList(), root));
};
var Companion_instance;
function Companion_getInstance_1() {
  return Companion_instance;
}
function AsciiCharTree(root) {
  this.h4d_1 = root;
}
function getImpl($this, index) {
  return bufferForIndex($this, index)[index % ensureNotNull($this.q48_1).length | 0];
}
function copy($this, startIndex, endIndex) {
  if (startIndex === endIndex)
    return '';
  var builder = StringBuilder_init_$Create$_0(endIndex - startIndex | 0);
  var buffer;
  var base = startIndex - (startIndex % 2048 | 0) | 0;
  while (base < endIndex) {
    buffer = bufferForIndex($this, base);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = startIndex - base | 0;
    var innerStartIndex = Math.max(0, b);
    // Inline function 'kotlin.comparisons.minOf' call
    var a = endIndex - base | 0;
    var innerEndIndex = Math.min(a, 2048);
    var inductionVariable = innerStartIndex;
    if (inductionVariable < innerEndIndex)
      do {
        var innerIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        builder.c8(buffer[innerIndex]);
      }
       while (inductionVariable < innerEndIndex);
    base = base + 2048 | 0;
  }
  return builder;
}
function SubSequenceImpl($outer, start, end) {
  this.l4d_1 = $outer;
  this.i4d_1 = start;
  this.j4d_1 = end;
  this.k4d_1 = null;
}
protoOf(SubSequenceImpl).a = function () {
  return this.j4d_1 - this.i4d_1 | 0;
};
protoOf(SubSequenceImpl).b = function (index) {
  var withOffset = index + this.i4d_1 | 0;
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'index is negative: ' + index;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(withOffset < this.j4d_1)) {
    var message_0 = 'index (' + index + ') should be less than length (' + this.a() + ')';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  return getImpl(this.l4d_1, withOffset);
};
protoOf(SubSequenceImpl).c = function (startIndex, endIndex) {
  // Inline function 'kotlin.require' call
  if (!(startIndex >= 0)) {
    var message = 'start is negative: ' + startIndex;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(startIndex <= endIndex)) {
    var message_0 = 'start (' + startIndex + ') should be less or equal to end (' + endIndex + ')';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!(endIndex <= (this.j4d_1 - this.i4d_1 | 0))) {
    var message_1 = 'end should be less than length (' + this.a() + ')';
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
  if (startIndex === endIndex)
    return '';
  return new SubSequenceImpl(this.l4d_1, this.i4d_1 + startIndex | 0, this.i4d_1 + endIndex | 0);
};
protoOf(SubSequenceImpl).toString = function () {
  var tmp0_elvis_lhs = this.k4d_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_0 = toString(copy(this.l4d_1, this.i4d_1, this.j4d_1));
    this.k4d_1 = this_0;
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(SubSequenceImpl).equals = function (other) {
  if (!(!(other == null) ? isCharSequence(other) : false))
    return false;
  if (!(charSequenceLength(other) === this.a()))
    return false;
  return rangeEqualsImpl(this.l4d_1, this.i4d_1, other, 0, this.a());
};
protoOf(SubSequenceImpl).hashCode = function () {
  var tmp0_safe_receiver = this.k4d_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
  return tmp1_elvis_lhs == null ? hashCodeImpl(this.l4d_1, this.i4d_1, this.j4d_1) : tmp1_elvis_lhs;
};
function bufferForIndex($this, index) {
  var list = $this.p48_1;
  if (list == null) {
    if (index >= 2048) {
      throwSingleBuffer($this, index);
    }
    var tmp0_elvis_lhs = $this.q48_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSingleBuffer($this, index);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  return list.o(index / ensureNotNull($this.q48_1).length | 0);
}
function throwSingleBuffer($this, index) {
  if ($this.s48_1)
    throw IllegalStateException_init_$Create$('Buffer is already released');
  throw IndexOutOfBoundsException_init_$Create$('' + index + ' is not in range [0; ' + currentPosition($this) + ')');
}
function nonFullBuffer($this) {
  return $this.t48_1 === 0 ? appendNewArray($this) : ensureNotNull($this.q48_1);
}
function appendNewArray($this) {
  var newBuffer = $this.o48_1.c3o();
  var existing = $this.q48_1;
  $this.q48_1 = newBuffer;
  $this.t48_1 = newBuffer.length;
  $this.s48_1 = false;
  if (!(existing == null)) {
    var tmp0_elvis_lhs = $this.p48_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = ArrayList_init_$Create$();
      $this.p48_1 = this_0;
      this_0.e(existing);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    list.e(newBuffer);
  }
  return newBuffer;
}
function rangeEqualsImpl($this, start, other, otherStart, length) {
  var inductionVariable = 0;
  if (inductionVariable < length)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(getImpl($this, start + i | 0) === charSequenceGet(other, otherStart + i | 0)))
        return false;
    }
     while (inductionVariable < length);
  return true;
}
function hashCodeImpl($this, start, end) {
  var hc = 0;
  var inductionVariable = start;
  if (inductionVariable < end)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = imul(31, hc);
      // Inline function 'kotlin.code' call
      var this_0 = getImpl($this, i);
      hc = tmp + Char__toInt_impl_vasixd(this_0) | 0;
    }
     while (inductionVariable < end);
  return hc;
}
function currentPosition($this) {
  return ensureNotNull($this.q48_1).length - $this.t48_1 | 0;
}
function CharArrayBuilder(pool) {
  pool = pool === VOID ? get_CharArrayPool() : pool;
  this.o48_1 = pool;
  this.p48_1 = null;
  this.q48_1 = null;
  this.r48_1 = null;
  this.s48_1 = false;
  this.t48_1 = 0;
  this.u48_1 = 0;
}
protoOf(CharArrayBuilder).a = function () {
  return this.u48_1;
};
protoOf(CharArrayBuilder).b = function (index) {
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'index is negative: ' + index;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(index < this.u48_1)) {
    var message_0 = 'index ' + index + ' is not in range [0, ' + this.u48_1 + ')';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  return getImpl(this, index);
};
protoOf(CharArrayBuilder).c = function (startIndex, endIndex) {
  // Inline function 'kotlin.require' call
  if (!(startIndex <= endIndex)) {
    var message = 'startIndex (' + startIndex + ') should be less or equal to endIndex (' + endIndex + ')';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(startIndex >= 0)) {
    var message_0 = 'startIndex is negative: ' + startIndex;
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!(endIndex <= this.u48_1)) {
    var message_1 = 'endIndex (' + endIndex + ') is greater than length (' + this.u48_1 + ')';
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
  return new SubSequenceImpl(this, startIndex, endIndex);
};
protoOf(CharArrayBuilder).toString = function () {
  var tmp0_elvis_lhs = this.r48_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_0 = toString(copy(this, 0, this.u48_1));
    this.r48_1 = this_0;
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(CharArrayBuilder).equals = function (other) {
  if (!(!(other == null) ? isCharSequence(other) : false))
    return false;
  if (!(this.u48_1 === charSequenceLength(other)))
    return false;
  return rangeEqualsImpl(this, 0, other, 0, this.u48_1);
};
protoOf(CharArrayBuilder).hashCode = function () {
  var tmp0_safe_receiver = this.r48_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
  return tmp1_elvis_lhs == null ? hashCodeImpl(this, 0, this.u48_1) : tmp1_elvis_lhs;
};
protoOf(CharArrayBuilder).c8 = function (value) {
  nonFullBuffer(this)[ensureNotNull(this.q48_1).length - this.t48_1 | 0] = value;
  this.r48_1 = null;
  this.t48_1 = this.t48_1 - 1 | 0;
  this.u48_1 = this.u48_1 + 1 | 0;
  return this;
};
protoOf(CharArrayBuilder).fc = function (value, startIndex, endIndex) {
  if (value == null)
    return this;
  var current = startIndex;
  while (current < endIndex) {
    var buffer = nonFullBuffer(this);
    var offset = buffer.length - this.t48_1 | 0;
    var tmp0 = endIndex - current | 0;
    // Inline function 'kotlin.math.min' call
    var b = this.t48_1;
    var bytesToCopy = Math.min(tmp0, b);
    var inductionVariable = 0;
    if (inductionVariable < bytesToCopy)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        buffer[offset + i | 0] = charSequenceGet(value, current + i | 0);
      }
       while (inductionVariable < bytesToCopy);
    current = current + bytesToCopy | 0;
    this.t48_1 = this.t48_1 - bytesToCopy | 0;
  }
  this.r48_1 = null;
  this.u48_1 = this.u48_1 + (endIndex - startIndex | 0) | 0;
  return this;
};
protoOf(CharArrayBuilder).f = function (value) {
  if (value == null)
    return this;
  return this.fc(value, 0, charSequenceLength(value));
};
protoOf(CharArrayBuilder).a28 = function () {
  var list = this.p48_1;
  if (!(list == null)) {
    this.q48_1 = null;
    var inductionVariable = 0;
    var last = list.m();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.o48_1.d3o(list.o(i));
      }
       while (inductionVariable < last);
  } else {
    var tmp0_safe_receiver = this.q48_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.o48_1.d3o(tmp0_safe_receiver);
    }
    this.q48_1 = null;
  }
  this.s48_1 = true;
  this.p48_1 = null;
  this.r48_1 = null;
  this.u48_1 = 0;
  this.t48_1 = 0;
};
function get_CharArrayPool() {
  _init_properties_CharArrayPool_kt__u4nq0d();
  return CharArrayPool;
}
var CharArrayPool;
function CharArrayPool$1() {
  NoPoolImpl.call(this);
}
protoOf(CharArrayPool$1).c3o = function () {
  return charArray(2048);
};
function CharArrayPool$2() {
  DefaultPool.call(this, 4096);
}
protoOf(CharArrayPool$2).v3n = function () {
  return charArray(2048);
};
var properties_initialized_CharArrayPool_kt_aq0u0f;
function _init_properties_CharArrayPool_kt__u4nq0d() {
  if (!properties_initialized_CharArrayPool_kt_aq0u0f) {
    properties_initialized_CharArrayPool_kt_aq0u0f = true;
    var tmp;
    if (isPoolingDisabled()) {
      tmp = new CharArrayPool$1();
    } else {
      tmp = new CharArrayPool$2();
    }
    CharArrayPool = tmp;
  }
}
var DefaultHttpMethods;
var HexTable;
var HexLetterTable;
function parseDecLong(_this__u8e3s4) {
  _init_properties_Chars_kt__d3i39x();
  var length = charSequenceLength(_this__u8e3s4);
  if (length > 19) {
    numberFormatException(_this__u8e3s4);
  }
  if (length === 19)
    return parseDecLongWithCheck(_this__u8e3s4);
  var result = new Long(0, 0);
  var inductionVariable = 0;
  if (inductionVariable < length)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.code' call
      var this_0 = charSequenceGet(_this__u8e3s4, i);
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      var digit = toLong(tmp$ret$0).s2(new Long(48, 0));
      if (digit.b1(new Long(0, 0)) < 0 || digit.b1(new Long(9, 0)) > 0) {
        numberFormatException_0(_this__u8e3s4, i);
      }
      result = result.b3(3).r2(result.b3(1)).r2(digit);
    }
     while (inductionVariable < length);
  return result;
}
function hashCodeLowerCase(_this__u8e3s4, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? charSequenceLength(_this__u8e3s4) : end;
  _init_properties_Chars_kt__d3i39x();
  var hashCode = 0;
  var inductionVariable = start;
  if (inductionVariable < end)
    do {
      var pos = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.code' call
      var this_0 = charSequenceGet(_this__u8e3s4, pos);
      // Inline function 'io.ktor.http.cio.internals.toLowerCase' call
      var this_1 = Char__toInt_impl_vasixd(this_0);
      var tmp;
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(65);
      var containsLower = Char__toInt_impl_vasixd(this_2);
      var tmp_0;
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(90);
      if (this_1 <= Char__toInt_impl_vasixd(this_3)) {
        tmp_0 = containsLower <= this_1;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        // Inline function 'kotlin.code' call
        var this_4 = _Char___init__impl__6a9atx(97);
        var tmp_1 = Char__toInt_impl_vasixd(this_4);
        // Inline function 'kotlin.code' call
        var this_5 = _Char___init__impl__6a9atx(65);
        tmp = tmp_1 + (this_1 - Char__toInt_impl_vasixd(this_5) | 0) | 0;
      } else {
        tmp = this_1;
      }
      var v = tmp;
      hashCode = imul(31, hashCode) + v | 0;
    }
     while (inductionVariable < end);
  return hashCode;
}
function equalsLowerCase(_this__u8e3s4, start, end, other) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? charSequenceLength(_this__u8e3s4) : end;
  _init_properties_Chars_kt__d3i39x();
  if (!((end - start | 0) === charSequenceLength(other)))
    return false;
  var inductionVariable = start;
  if (inductionVariable < end)
    do {
      var pos = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.code' call
      var this_0 = charSequenceGet(_this__u8e3s4, pos);
      // Inline function 'io.ktor.http.cio.internals.toLowerCase' call
      var this_1 = Char__toInt_impl_vasixd(this_0);
      var tmp;
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(65);
      var containsLower = Char__toInt_impl_vasixd(this_2);
      var tmp_0;
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(90);
      if (this_1 <= Char__toInt_impl_vasixd(this_3)) {
        tmp_0 = containsLower <= this_1;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        // Inline function 'kotlin.code' call
        var this_4 = _Char___init__impl__6a9atx(97);
        var tmp_1 = Char__toInt_impl_vasixd(this_4);
        // Inline function 'kotlin.code' call
        var this_5 = _Char___init__impl__6a9atx(65);
        tmp = tmp_1 + (this_1 - Char__toInt_impl_vasixd(this_5) | 0) | 0;
      } else {
        tmp = this_1;
      }
      var tmp_2 = tmp;
      // Inline function 'kotlin.code' call
      var this_6 = charSequenceGet(other, pos - start | 0);
      // Inline function 'io.ktor.http.cio.internals.toLowerCase' call
      var this_7 = Char__toInt_impl_vasixd(this_6);
      var tmp_3;
      // Inline function 'kotlin.code' call
      var this_8 = _Char___init__impl__6a9atx(65);
      var containsLower_0 = Char__toInt_impl_vasixd(this_8);
      var tmp_4;
      // Inline function 'kotlin.code' call
      var this_9 = _Char___init__impl__6a9atx(90);
      if (this_7 <= Char__toInt_impl_vasixd(this_9)) {
        tmp_4 = containsLower_0 <= this_7;
      } else {
        tmp_4 = false;
      }
      if (tmp_4) {
        // Inline function 'kotlin.code' call
        var this_10 = _Char___init__impl__6a9atx(97);
        var tmp_5 = Char__toInt_impl_vasixd(this_10);
        // Inline function 'kotlin.code' call
        var this_11 = _Char___init__impl__6a9atx(65);
        tmp_3 = tmp_5 + (this_7 - Char__toInt_impl_vasixd(this_11) | 0) | 0;
      } else {
        tmp_3 = this_7;
      }
      if (!(tmp_2 === tmp_3))
        return false;
    }
     while (inductionVariable < end);
  return true;
}
function numberFormatException(cs) {
  _init_properties_Chars_kt__d3i39x();
  throw NumberFormatException_init_$Create$('Invalid number ' + toString(cs) + ': too large for Long type');
}
function parseDecLongWithCheck(_this__u8e3s4) {
  _init_properties_Chars_kt__d3i39x();
  var result = new Long(0, 0);
  var inductionVariable = 0;
  var last = charSequenceLength(_this__u8e3s4) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.code' call
      var this_0 = charSequenceGet(_this__u8e3s4, i);
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      var digit = toLong(tmp$ret$0).s2(new Long(48, 0));
      if (digit.b1(new Long(0, 0)) < 0 || digit.b1(new Long(9, 0)) > 0) {
        numberFormatException_0(_this__u8e3s4, i);
      }
      result = result.b3(3).r2(result.b3(1)).r2(digit);
      if (result.b1(new Long(0, 0)) < 0) {
        numberFormatException(_this__u8e3s4);
      }
    }
     while (inductionVariable <= last);
  return result;
}
function numberFormatException_0(cs, idx) {
  _init_properties_Chars_kt__d3i39x();
  throw NumberFormatException_init_$Create$('Invalid number: ' + toString(cs) + ', wrong digit: ' + toString_1(charSequenceGet(cs, idx)) + ' at position ' + idx);
}
function DefaultHttpMethods$lambda(it) {
  _init_properties_Chars_kt__d3i39x();
  return it.n41_1.length;
}
function DefaultHttpMethods$lambda_0(m, idx) {
  _init_properties_Chars_kt__d3i39x();
  return new Char(charSequenceGet(m.n41_1, idx));
}
var properties_initialized_Chars_kt_phjfhp;
function _init_properties_Chars_kt__d3i39x() {
  if (!properties_initialized_Chars_kt_phjfhp) {
    properties_initialized_Chars_kt_phjfhp = true;
    var tmp = Companion_instance;
    var tmp_0 = Companion_getInstance().m41_1;
    var tmp_1 = DefaultHttpMethods$lambda;
    DefaultHttpMethods = tmp.g4d(tmp_0, tmp_1, DefaultHttpMethods$lambda_0);
    // Inline function 'kotlin.collections.map' call
    var this_0 = numberRangeToNumber(0, 255);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.v_1;
    var last = this_0.w_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v = item;
        var tmp_2;
        if (48 <= v ? v <= 57 : false) {
          tmp_2 = numberToLong(v).s2(new Long(48, 0));
        } else {
          var tmp_3;
          var tmp_4 = toLong(v);
          // Inline function 'kotlin.code' call
          var this_1 = _Char___init__impl__6a9atx(97);
          var tmp$ret$0 = Char__toInt_impl_vasixd(this_1);
          if (tmp_4.b1(toLong(tmp$ret$0)) >= 0) {
            var tmp_5 = toLong(v);
            // Inline function 'kotlin.code' call
            var this_2 = _Char___init__impl__6a9atx(102);
            var tmp$ret$1 = Char__toInt_impl_vasixd(this_2);
            tmp_3 = tmp_5.b1(toLong(tmp$ret$1)) <= 0;
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            // Inline function 'kotlin.code' call
            var this_3 = _Char___init__impl__6a9atx(97);
            var tmp$ret$2 = Char__toInt_impl_vasixd(this_3);
            // Inline function 'kotlin.Long.plus' call
            tmp_2 = numberToLong(v).s2(toLong(tmp$ret$2)).r2(toLong(10));
          } else {
            var tmp_6;
            var tmp_7 = toLong(v);
            // Inline function 'kotlin.code' call
            var this_4 = _Char___init__impl__6a9atx(65);
            var tmp$ret$4 = Char__toInt_impl_vasixd(this_4);
            if (tmp_7.b1(toLong(tmp$ret$4)) >= 0) {
              var tmp_8 = toLong(v);
              // Inline function 'kotlin.code' call
              var this_5 = _Char___init__impl__6a9atx(70);
              var tmp$ret$5 = Char__toInt_impl_vasixd(this_5);
              tmp_6 = tmp_8.b1(toLong(tmp$ret$5)) <= 0;
            } else {
              tmp_6 = false;
            }
            if (tmp_6) {
              // Inline function 'kotlin.code' call
              var this_6 = _Char___init__impl__6a9atx(65);
              var tmp$ret$6 = Char__toInt_impl_vasixd(this_6);
              // Inline function 'kotlin.Long.plus' call
              tmp_2 = numberToLong(v).s2(toLong(tmp$ret$6)).r2(toLong(10));
            } else {
              tmp_2 = new Long(-1, -1);
            }
          }
        }
        var tmp$ret$8 = tmp_2;
        destination.e(tmp$ret$8);
      }
       while (!(item === last));
    HexTable = toLongArray(destination);
    // Inline function 'kotlin.collections.map' call
    var this_7 = numberRangeToNumber(0, 15);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_7, 10));
    var inductionVariable_0 = this_7.v_1;
    var last_0 = this_7.w_1;
    if (inductionVariable_0 <= last_0)
      do {
        var item_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var it = item_0;
        var tmp_9;
        if (it < 10) {
          tmp_9 = toByte(48 + it | 0);
        } else {
          // Inline function 'kotlin.code' call
          var this_8 = Char__minus_impl_a2frrh(Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(97), it), 10);
          var tmp$ret$0_0 = Char__toInt_impl_vasixd(this_8);
          tmp_9 = toByte(tmp$ret$0_0);
        }
        var tmp$ret$1_0 = tmp_9;
        destination_0.e(tmp$ret$1_0);
      }
       while (!(item_0 === last_0));
    HexLetterTable = toByteArray(destination_0);
  }
}
function UnsupportedMediaTypeExceptionCIO(message) {
  IOException_init_$Init$(message, this);
  captureStack(this, UnsupportedMediaTypeExceptionCIO);
}
function MutableRange(start, end) {
  this.q49_1 = start;
  this.r49_1 = end;
}
protoOf(MutableRange).toString = function () {
  return 'MutableRange(start=' + this.q49_1 + ', end=' + this.r49_1 + ')';
};
function skipSpacesAndHorizontalTabs(text, start, end) {
  var index = start;
  $l$loop: while (index < end) {
    var ch = text.b(index);
    if (!isWhitespace(ch) && !(ch === _Char___init__impl__6a9atx(9)))
      break $l$loop;
    index = index + 1 | 0;
  }
  return index;
}
function isPoolingDisabled() {
  return false;
}
//region block: init
Companion_instance = new Companion();
//endregion
//region block: exports
export {
  CIOMultipartDataBase as CIOMultipartDataBase3o5u8w437tq5s,
};
//endregion

